import {
  anAction,
  anInsight,
  anInsightStatusName,
  aSignal,
  aTeamPage,
  aUser,
  aUserPage,
  InsightDetailInsightFragment,
  InsightQueryOperationQuery,
  mockInsightQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import {
  CUSTOM_INSIGHT_RESOLUTION,
  PARENT_NAME,
} from './InsightResolutionQueryOperation.mocks';
import { mockInsight } from './InsightsListQueryOperation.mocks';
import {
  CLOSED_STATUS_DISPLAY_NAME,
  CLOSED_STATUS_NAME,
  NEW_STATUS_DISPLAY_NAME,
  NEW_STATUS_NAME,
} from './InsightStatusesOperation.mocks';

const baseInsightOverrides = {
  readableId: mockInsight.readableId,
  signals: [aSignal()],
  assignee: {
    ...aUser(), // assignee is not guaranteed to have username associated with it, this forces it to be a user with a username
  },
  status: {
    ...anInsightStatusName({
      name: NEW_STATUS_NAME,
      displayName: NEW_STATUS_DISPLAY_NAME,
    }),
  },
  // The mocked response has gotten too large for the Cypress tests to parse. This was causing the insight.spec to fail with new schema additions.
  // Setting a bunch of stuff that isn't being tested explicitly to reduce the payload size.
  enrichments: [],
  relatedEnrichments: [],
  comments: [],
  involvedEntities: [],
  relatedIncidents: [],
  relatedInsights: [],
};

export const insightQueryClosedStatus = {
  resolution: PARENT_NAME,
  subResolution: CUSTOM_INSIGHT_RESOLUTION.name,
  status: {
    ...anInsightStatusName({
      name: CLOSED_STATUS_NAME,
      displayName: CLOSED_STATUS_DISPLAY_NAME,
    }),
  },
};

export const mockInsightQuery: InsightQueryOperationQuery = {
  __typename: 'Query',
  actions: [anAction()],
  insight: anInsight({
    resolution: null,
    subResolution: null,
    ...baseInsightOverrides,
  }) as InsightDetailInsightFragment,
  teams: aTeamPage(),
  users: aUserPage(),
};

export const handlers = [
  mockInsightQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: mockInsightQuery,
      });
    }
  ),
];
